import { AccessPermissions } from '@circlefin/permissions'
import { Role } from '@circlefin/permissions/roles'
import { SynthRole } from '@services/synthetic-roles'

import type { PermissionSet } from '@circlefin/permissions'

/**
 * Access to view proposals features.
 */
export const PROPOSAL_QUERY: PermissionSet = {
  access: AccessPermissions.protected,
  includeAll: [
    SynthRole.SYNTH_NEW_APPROVAL_WORKFLOW_ONE,
    Role.ACTIVITY_CENTER_READ_ROLE,
  ],
}
